package com.macrofocus.eflux.ui

import com.macrofocus.common.properties.Property
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.network.GraphicalNetwork
import com.macrofocus.eflux.network.LinkField
import com.macrofocus.eflux.network.NodeField
import com.macrofocus.eflux.toRawString
import i18next.invoke
import i18next.useTranslation
import js.objects.unsafeJso
import js.string.asString
import mui.material.*
import mui.material.StackDirection.Companion.row
import mui.system.responsive
import mui.system.sx
import org.mkui.react.useProperty
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import react.*
import react.dom.events.ChangeEvent
import web.cssom.Color
import web.cssom.px
import web.dom.ElementId
import web.dom.document
import web.html.*

val AppMenuComponent = FC<AppMenuProps> { props ->
//    val classes = useStyles()
    val (t, _) = useTranslation()

    val substations = false

    val (expertMode, _) = useProperty(props.dataLoader.exportMode)

    val (getSizeNodes, setSizeNodes) = useProperty(props.dataLoader.sizeNodes)
    val (getColorNodes, setColorNodes) = useProperty(props.dataLoader.colorNodes)
    val (getHeatmapNodes, _) = useProperty(props.dataLoader.heatmapNodes)
    var tooltipNodes by useProperty(props.dataLoader.tooltipNodes)

    val (getAnimationLinks, setAnimationLinks) = useProperty(props.dataLoader.animationLinks)
    val (getTooltips, setTooltips) = useProperty(props.dataLoader.tooltips)
    var tooltipLinks by useProperty(props.dataLoader.tooltipLinks)
    val (getLOD, setLOD) = useProperty(props.dataLoader.lod)
    val (getGenerators, setGenerators) = useProperty(props.dataLoader.generators)
    val (getLightning, setLightning) = useProperty(props.dataLoader.lightning)
    val (getWeather, setWeather) = useProperty(props.dataLoader.weather)
    val (getTerrain, setTerrain) = useProperty(props.dataLoader.terrain)
    val (autoTerrain, setAutoTerrain) = useProperty(props.dataLoader.autoTerrain)
    val (getThreeDArc, setThreeDArc) = useProperty(props.dataLoader.threeDArc)

    val (fullName, setFullName) = useProperty(props.dataLoader.fullName)
    val (autoZoom, setAutoZoom) = useProperty(props.dataLoader.autoMorphing)
    val (schematic, setSchematic) = useProperty(props.dataLoader.schematic)
    val (autoMorphing, setAutoMorphing) = useProperty(props.dataLoader.autoMorphing)
    val (cartographic, setCartographic) = useProperty(props.dataLoader.cartographic)
    val (lineWidth, setLineWidth) = useProperty(props.dataLoader.lineWidth)
    val (fps, setFps) = useProperty(props.dataLoader.fps)
    val (riskBuffer, setRiskBuffer) = useProperty(props.dataLoader.riskBuffer)
    val (riskThreshold, setRiskThreshold) = useProperty(props.dataLoader.riskThreshold)


    // Filler for the same height as the App bar
//    Toolbar {
//    }

    List {


        // Display version information?
//        ListItem {
//            sx = unsafeJso {
//                marginTop = 8.px // theme.spacing(1)
//                marginLeft = 62.px // theme.spacing(8)
//                marginBottom = 4.px // theme.spacing(1)
//            }
//
//            ListItemText {
//                primary = Typography.create() {
//                    variant = TypographyVariant.caption
//                    +"v. ${BuildKonfig.efluxVersion}"
//                }
//            }
//        }
//        Divider {}

        if (expertMode) {
            Subtitle1 {
                label = t("appMenu.views.label")
            }
        }
        if (props.graphicalNetwork != null) {
            val downloadSVGFunction: (() -> Unit) = {
                downloadTextFile(
                    props.graphicalNetwork!!.value?.svg?.outerHTML?.asStringOrNull(),
                    "eflux-" + props.dataLoader.masterDateTime.value.toRawString() + ".svg"
                )
            }
            val downloadPNGFunction: (() -> Unit) = {
                val div = document.getElementById(ElementId("deckgl-overlay"))
                downloadPNGFile(
                    div,
                    "eflux-" + props.dataLoader.masterDateTime.value.toRawString() + ".png"
                )
            }
            val onDownload = if (props.dataLoader.download.value) downloadSVGFunction else null
//            NestedListItem {
//                id = "main"
//                label = t("appMenu.views.attributes")
//                onClick = { history.toRoot() }
//                this.onDownload = onDownload
//            }

            if (onDownload != null) {
                Divider {}

                Button {
                    onClick = {
                        if (downloadSVGFunction != null) {
                            downloadSVGFunction()
                        }
                    }
                    +"Download SVG"
                }

                Button {
                    onClick = {
                        if (downloadPNGFunction != null) {
                            downloadPNGFunction()
                        }
                    }
                    +"Download PNG"
                }
            }
        }

        if (expertMode) {
            Divider {}
            //        subtitle1(classes, t("appMenu.configuration.label"))
        }

        Subtitle1 {
            label = t("appMenu.configuration.nodes.label")
        }

        // Nodes - Heatmap
        if (expertMode) {
            NodeSingleSelect {
                tkey = "appMenu.configuration.nodes.heatmap"
                labelId = "appMenu.configuration.nodes.heatmap-label"
                field = props.dataLoader.heatmapNodes
                fields = NodeField.heatmap
            }
        }

        if (substations) {
            // Nodes - Size
            FormControl {
                //            attrs.classes(classes.formControl)
                //            attrs.variant = FormControlVariant.outlined
                InputLabel {
                    id = ElementId("appMenu.configuration.nodes.size-label")
//                    attrs.classes(classes.inputLabel)
                    +t("appMenu.configuration.nodes.size")
                }
                Select {
//                    attrs.classes = classes.select
                    sx {
                        marginBottom = 10.px
                    }
                    labelId = "appMenu.configuration.nodes.size-label"
                    label = ReactNode(t("appMenu.configuration.nodes.size"))
                    id = ElementId("appMenu.configuration.nodes.size")
                    margin = InputBaseMargin.dense
                    displayEmpty = true
                    value = (getSizeNodes ?: "").unsafeCast<Nothing?>()
                    renderValue = {
                        ListItemText.create() {
                            if (it is Array<*>) {
                                primary = ReactNode(it.joinToString())
                            } else {
                                if (it != null) {
                                    primary = ReactNode(it.toString())
                                } else {
                                    primary = ReactNode("")
                                }
                            }
                        }
                    }
                    val onChangeFunction: (ChangeEvent<HTMLInputElement,*>, ReactNode) -> Unit = { it, node ->
                        val value = it.asDynamic().target.value
                        val field: NodeField<*>? = if (value != "" && value is NodeField<*>) value else null
                        setSizeNodes(field)
                    }
                    onChange = onChangeFunction

                    MenuItem {
                        dense = true
                        value = ""
                        ListItemText { +"None" }
                    }
                    NodeField.size.forEach {
                        MenuItem {
                            dense = true
                            value = it.unsafeCast<Nothing?>()
                            val icon = it.icon
                            if (icon != null) {
                                ListItemIcon { Icon { +icon } }
                            }
                            ListItemText { +it.toString() }
                        }
                    }
                }
            }
        }

        // Nodes - Color
        if (expertMode) {
            FieldControl {
                //            attrs.classes(classes.formControl)
                //            attrs.variant = FormControlVariant.outlined
                InputLabel {
                    id = ElementId("appMenu.configuration.nodes.color-label")
                    //                    attrs.classes = classes.inputLabel
                    +t("appMenu.configuration.nodes.color")
                }
                Select {
                    //                    attrs.classes = classes.select
                    sx {
                        marginBottom = 10.px
                    }
                    labelId = "appMenu.configuration.nodes.color-label"
                    label = ReactNode(t("appMenu.configuration.nodes.color"))
                    id = ElementId("appMenu.configuration.nodes.color")
                    margin = InputBaseMargin.dense
                    displayEmpty = true
                    value = (getColorNodes ?: "").unsafeCast<Nothing?>()
                    renderValue = {
                        ListItemText.create() {
                            if (it is Array<*>) {
                                primary = ReactNode(it.joinToString())
                            } else {
                                if (it != null) {
                                    primary = ReactNode(it.toString())
                                } else {
                                    primary = ReactNode("")
                                }
                            }
                        }
                    }
                    val onChangeFunction: (ChangeEvent<HTMLInputElement,*>, ReactNode) -> Unit = { it, node ->
                        val value = it.asDynamic().target.value
                        val field: NodeField<*>? = if (value != "" && value is NodeField<*>) value else null
                        setColorNodes(field)
                    }
                    onChange = onChangeFunction

                    MenuItem {
                        dense = true
                        value = ""
                        ListItemText { +"None" }
                    }
                    NodeField.color.forEach {
                        MenuItem {
                            dense = true
                            value = it.unsafeCast<Nothing?>()
                            val icon = it.icon
                            if (icon != null) {
                                ListItemIcon { Icon { +icon } }
                            }
                            ListItemText { +it.toString() }
                        }
                    }
                }
            }
        }

        // Nodes - Tooltip
        if (substations) {
            FieldControl {
                InputLabel {
                    id = ElementId("appMenu.configuration.nodes.tooltip-label")
//                    attrs.classes = classes.inputLabel
                    +t("appMenu.configuration.nodes.tooltip")
                }
                Select {
//                    attrs.classes = classes.select
                    sx {
                        marginBottom = 10.px
                    }
                    labelId = "appMenu.configuration.nodes.tooltip-label"
                    label = ReactNode(t("appMenu.configuration.nodes.tooltip"))
                    id = ElementId("appMenu.configuration.nodes.tooltip")
                    margin = InputBaseMargin.dense
                    multiple = true
                    displayEmpty = false
                    value = tooltipNodes.unsafeCast<Nothing?>()
                    renderValue = {
                        ListItemText.create() {
                            if(it is Array<*>) {
                                primary = ReactNode(it.joinToString())
                            } else {
                                if(it != null) {
                                    primary = ReactNode(it.toString())
                                } else {
                                    primary = ReactNode("")
                                }
                            }
                        }
                    }
                    val onChangeFunction: (ChangeEvent<HTMLInputElement,*>, ReactNode) -> Unit = { it, node ->
                        tooltipNodes = it.asDynamic().target.value
                    }
                    onChange = onChangeFunction

                    NodeField.tooltip.forEach {
                        MenuItem {
                            dense = true
                            value = it.unsafeCast<Nothing?>()
                            val icon = it.icon
                            if (icon != null) {
                                ListItemIcon { Icon { +icon } }
                            }
                            ListItemText { +it.toString() }
                        }
                    }
                }
            }
        }

        Subtitle1 {
            label = t("appMenu.configuration.links.label")
        }

        // Links - Thickness
        LinkSingleSelect {
            tkey = "appMenu.configuration.links.thickness"
            labelId = "appMenu.configuration.links.thickness-label"
            field = props.dataLoader.thicknessLinks
            fields = LinkField.thickness
        }

        // Links - Color
        LinkSingleSelect {
            tkey = "appMenu.configuration.links.color"
            labelId = "appMenu.configuration.links.color-label"
            field = props.dataLoader.colorLinks
            fields = LinkField.color
        }

        // Links - Heatmap
        if(expertMode) {
            LinkSingleSelect {
                tkey = "appMenu.configuration.links.heatmap"
                labelId = "appMenu.configuration.links.heatmap-label"
                field = props.dataLoader.heatmapLinks
                fields = LinkField.heatmap
                disabled = getHeatmapNodes != null
            }
        }

        // Links - Movement
        LinkSingleSelect {
            tkey = "appMenu.configuration.links.movement"
            labelId = "appMenu.configuration.links.movement-label"
            field = props.dataLoader.movementLinks
            fields = LinkField.movement
        }

        // Links - Animations
        FieldControl {
            FormControlLabel {
                control = Switch.create() {
                    checked = getAnimationLinks
                    onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                        setAnimationLinks(!getAnimationLinks)
                    }
                }
                label = ReactNode(t("appMenu.configuration.links.animation"))
            }
        }

        // Tooltips
        if(expertMode) {
            FieldControl {
                FormControlLabel {
                    control = Switch.create() {
                        checked = getTooltips
                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                            setTooltips(!getTooltips)
                        }
                    }
                    label = ReactNode(t("appMenu.configuration.tooltips"))
                }
            }

            // Links - Tooltip
            FieldControl {
                InputLabel {
                    id = ElementId("appMenu.configuration.links.tooltip-label")
                    //                attrs.classes = classes.inputLabel
                    +t("appMenu.configuration.links.tooltip")
                }
                Select {
                    //                attrs.classes = classes.select
                    sx {
                        marginBottom = 10.px
                    }
                    labelId = "appMenu.configuration.links.tooltip-label"
                    label = ReactNode(t("appMenu.configuration.links.tooltip"))
                    id = ElementId("appMenu.configuration.links.label")
                    margin = InputBaseMargin.dense
                    multiple = true
                    displayEmpty = false
                    value = tooltipLinks.unsafeCast<Nothing?>()
                    renderValue = {
                        ListItemText.create() {
                            if (it is Array<*>) {
                                primary = ReactNode(it.joinToString())
                            } else {
                                if (it != null) {
                                    primary = ReactNode(it.toString())
                                } else {
                                    primary = ReactNode("")
                                }
                            }
                        }
                    }
                    val onChangeFunction: (ChangeEvent<HTMLInputElement,*>, ReactNode) -> Unit = { it, node ->
                        tooltipLinks = it.asDynamic().target.value
                    }
                    onChange = onChangeFunction

                    LinkField.tooltip.forEach {
                        MenuItem {
                            dense = true
                            value = it.unsafeCast<Nothing?>()
                            val icon = it.icon
                            if (icon != null) {
                                ListItemIcon { Icon { +icon } }
                            }
                            ListItemText { +it.toString() }
                        }
                    }
                }
            }
        }

        // LoD
        if(expertMode) {
            FieldControl {
                FormControlLabel {
                    control = Switch.create() {
                        checked = getLOD
                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                            setLOD(!getLOD)
                        }
                    }
                    label = ReactNode(t("appMenu.configuration.lod"))
                }
            }
        }

        // Generators
        if(expertMode) {
            FieldControl {
                FormControlLabel {
                    control = Switch.create() {
                        checked = getGenerators
                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                            setGenerators(!getGenerators)
                        }
                    }
                    label = ReactNode(t("appMenu.configuration.generators"))
                }
            }
        }

        // Lightning
        if(expertMode) {
            FieldControl {
                FormControlLabel {
                    control = Switch.create() {
                        checked = getLightning
                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                            setLightning(!getLightning)
                        }
                    }
                    label = ReactNode(t("appMenu.configuration.lightning"))
                }
            }
        }

        // Weather
        if(expertMode) {
            FieldControl {
                FormControlLabel {
                    control = Switch.create() {
                        checked = getWeather
                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                            setWeather(!getWeather)
                        }
                    }
                    label = ReactNode(t("appMenu.configuration.weather"))
                }
            }
        }

        // Terrain
        FieldControl {
            FormControlLabel {
                control = Switch.create() {
                    checked = autoTerrain
                    onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                        setAutoTerrain(!autoTerrain)
                    }
                }
                label = ReactNode(t("Automatic terrain"))
            }
        }
        FieldControl {
            FormControlLabel {
                control = Switch.create() {
                    checked = getTerrain
                    onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                        setTerrain(!getTerrain)
                    }
                }
                label = ReactNode(t("appMenu.configuration.terrain"))
            }
        }

        // Arcs
        if(expertMode) {
            FieldControl {
                FormControlLabel {
                    control = Switch.create() {
                        checked = getThreeDArc
                        onChange = { event: ChangeEvent<HTMLInputElement,*>, checked: Boolean ->
                            setThreeDArc(!getThreeDArc)
                        }
                    }
                    label = ReactNode(t("appMenu.configuration.arcs"))
                }
            }
        }

        fun isSelected(variable: String): Boolean = schematic == variable

        if(expertMode) {
            Typography {
                +"Schematic"
            }

            Stack {
                spacing = responsive(2) // Adds spacing between buttons
                direction = responsive(row) // Arrange buttons horizontally

                // Button for "eflux"
                Button {
                    +"EFLUX"
                    variant =
                        if (isSelected("eflux")) mui.material.ButtonVariant.contained else mui.material.ButtonVariant.outlined
                    sx {
                        backgroundColor =
                            if (isSelected("eflux")) Color("#1976d2") else Color("transparent") // Blue when selected
                        color = if (isSelected("eflux")) Color("white") else Color("black")
                    }
                    onClick = {
                        setSchematic("eflux")
                    }
                }

                // Button for "nevis"
                Button {
                    +"NEVIS"
                    disabled = false
                    variant =
                        if (isSelected("nevis")) mui.material.ButtonVariant.contained else mui.material.ButtonVariant.outlined
                    sx {
                        backgroundColor =
                            if (isSelected("nevis")) Color("#1976d2") else Color("transparent") // Blue when selected
                        color = if (isSelected("nevis")) Color("white") else Color("black")
                    }
                    onClick = {
                        setSchematic("nevis")
                    }
                }
            }
        }

        FormGroup {
            FormControlLabel {
                value = fullName
                onChange = { _, value ->
                    setFullName(value)
                }
                control = Switch.create() {
                    defaultChecked = fullName
                }
                label = ReactNode("Full Name")
            }
        }

        FormGroup {
            FormControlLabel {
                value = autoZoom
                onChange = { _, value ->
                    setAutoZoom(value)
                }
                control = Switch.create() {
                    defaultChecked = autoZoom
                }
                label = ReactNode("Automatic Zooming")
            }
        }

        FormGroup {
            FormControlLabel {
                value = autoMorphing
                onChange = { _, value ->
                    setAutoMorphing(value)
                }
                control = Switch.create() {
                    defaultChecked = autoMorphing
                }
                label = ReactNode("Automatic Morphing")
            }
        }

        Typography {
            +"Schematic<->Cartographic"
        }

        Slider {
            ariaLabel = "Schematic<->Cartographic"
            value = cartographic
            min = 0.0
            max = 10.0
            step = 0.25
            onChange = { _, newValue, _ -> setCartographic(newValue.unsafeCast<Number>().toDouble()) }
        }

        Typography {
            +"Line Width"
        }

        Slider {
//                        asDynamic()."aria-label" = "FPS"
            value = lineWidth
            min = 1.0
            max = 50.0
            marks = true
            valueLabelDisplay = "auto"
            onChange = { _, newValue, _ -> setLineWidth(newValue.unsafeCast<Number>().toDouble()) }
        }

        Typography {
            +"Throttle FPS"
        }

        Slider {
//                        asDynamic()."aria-label" = "FPS"
            value = fps
            min = 0.01
            max = 60.0
            marks = true
            valueLabelDisplay = "auto"
            onChange = { _, newValue, _ -> setFps(newValue.unsafeCast<Number>().toDouble()) }
        }

        Typography {
            +"Risk Buffer"
        }

        Slider {
//                        asDynamic()."aria-label" = "FPS"
            value = riskBuffer
            min = 1.0
            max = 30.0
            marks = true
            valueLabelDisplay = "auto"
            onChange = { _, newValue, _ -> setRiskBuffer(newValue.unsafeCast<Number>().toDouble()) }
        }

        Typography {
            +"Risk Threshold"
        }

        Slider {
//                        asDynamic()."aria-label" = "FPS"
            value = riskThreshold
            min = 1.0
            max = 30.0
            marks = true
            valueLabelDisplay = "auto"
            onChange = { _, newValue, _ -> setRiskThreshold(newValue.unsafeCast<Number>().toDouble()) }
        }
    }
}

fun downloadPNGFile(canvas: HTMLElement?, fileName: String) =
    (document.createElement("a") as HTMLAnchorElement).apply {
        href = (canvas as HTMLCanvasElement).toDataURL("image/png")
        download = fileName
        document.body.appendChild(this)
        click()
        document.body.removeChild(this)
    }

fun downloadTextFile(text: String?, fileName: String) =
    (document.createElement("a") as HTMLAnchorElement).apply {
        href = URL.createObjectURL(Blob(arrayOf(text)))
        download = fileName
        document.body.appendChild(this)
        click()
        document.body.removeChild(this)
    }

external interface Subtitle1Props : Props {
    //    classes: AppMenuStyle,
    var label: String
}

val Subtitle1 = FC<Subtitle1Props> { props ->
//    attrs.classes = classes.subtitle1

    Typography {
        sx = unsafeJso {
            marginLeft = 16.px // theme.spacing(8)
        }


//        attrs.classes(classes.subtitle1Label)
//        attrs.variant = TypographyVariant.subtitle1
        +props.label
    }
}

external interface NestedListItemProps : Props {
    //    classes: AppMenuStyle,
    var id: String
    var label: String
    var onClick: () -> Unit
    var onDownload: (() -> Unit)?
}

private val NestedListItem = FC<NestedListItemProps> { props ->
    List {
        key = Key(id!!.asString())
//    attrs.classes = classes.item
        Button {
//        attrs.classes = classes.itemButton
            onClick = { props.onClick() }
            +props.label
        }
        if (props.onDownload != null) {
            Fab {
                //            classes(classes.root)
                size = mui.material.Size.small
                title = "Download"
//                ariaLabel = "Download"
                //            color = ButtonColor.inherit
                onClick = {
                    props.onDownload!!()
                }

                Icon {
//                attrs.classes(classes.icon)
                    +"download_icon"
                }
            }
        }
    }
}

external interface AnchorItemProps : Props {
    //    classes: AppMenuStyle,
    var id: String
    var label: String
    var href: String
    var icon: String?
}

val AnchorItem = FC<AnchorItemProps> { props ->
    Link {
        href = props.href

        ListItem {
            sx = unsafeJso {
                paddingTop = 0.px
                paddingBottom = 0.px
            }

            key = Key(props.id)
            ListItemIcon {
                //            attrs.classes = classes.itemIcon

                if (props.icon != null) {
                    Icon { +props.icon!! }
                } else {
                    Icon { +"launch_icon" }
                }
            }
            ListItemText {
                primary = ReactNode(props.label)
                //            {
                //                Typography {
                //                    attrs.classes = classes.subtitle1Label
                //                    attrs.variant = TypographyVariant.subtitle1
                //                    +label
                //                }
                //            }
            }
        }
    }
}

external interface AppMenuProps : Props {
    var dataLoader: DataLoader
    var graphicalNetwork: Property<GraphicalNetwork?>?
    var onCloseMenu: (() -> Unit)?
}

//private external interface AppMenuStyle {
//    val title: String
//    val subtitle1: String
//    val subtitle1Label: String
//    val item: String
//    val itemButton: String
//    val itemIcon: String
//
//    val fieldControl: String
//    val formControl: String
//    val inputLabel: String
//    val select: String
//
//    val developed: String
//}

//private val useStyles = makeStyles<AppMenuStyle> {
//    "title" {
//        // Added top margin because appBar overlap
//        marginTop = 8.px // theme.spacing(1)
//        marginLeft = 62.px // theme.spacing(8)
//        marginBottom = 4.px // theme.spacing(1)
//    }
//    "subtitle1" {
//        display = Display.flex
//        paddingLeft = 8.px // theme.spacing(2)
//    }
//    "subtitle1Label" {
//        fontWeight = FontWeight.w700
//    }
//    "subtitle2" {
//        display = Display.flex
//        paddingLeft = 16.px // theme.spacing(4)
//    }
//    "subtitle2Label" {
//        fontWeight = FontWeight.w500
////        paddingLeft = theme.spacing(4)
//    }
//    "item" {
//        display = Display.flex
//        paddingTop = 0.px
//        paddingBottom = 0.px
//    }
//    "itemButton" {
//        width = 100.pct
//        paddingLeft = 16.px // theme.spacing(4)
//        justifyContent = JustifyContent.flexStart
//        textTransform = TextTransform.none
//    }
//    "itemIcon" {
//        minWidth = 36.px
//    }
//    "fieldControl" {
////        paddingLeft = theme.spacing(4)
//        width = 100.pct
////        marginTop = theme.spacing(1)
//        marginBottom = 8.px // theme.spacing(2)
//    }
//    "formControl" {
////        paddingLeft = theme.spacing(4)
//        width = 100.pct
////        justifyContent = JustifyContent.flexStart
////        textTransform = TextTransform.none
////        marginLeft = theme.spacing(1)
////        marginRight = theme.spacing(3)
////        marginTop = theme.spacing(1)
////        marginBottom = theme.spacing(1)
//    }
//    "inputLabel" {
////        paddingLeft = theme.spacing(4)
//    }
//    "select" {
////        paddingLeft = theme.spacing(4)
////        child("underline") {
////            before {
////                left = theme.spacing(4)
////            }
////        }
//    }
//    "developed" {
//        fontSize = 0.8.rem
//        paddingLeft = 5.2.rem
//        color = Color("#808080")
//    }
//}
